const state = {
  newPolygon: null,
  isOverlapping: false,
  selectedArea: null,
  sidebarMode: null,
  newAreaName: null,
}

const getters = {
  selectedArea: (state) => state.selectedArea,
  isOverlapping: (state) => state.isOverlapping,
  newPolygon: (state) => state.newPolygon,
  sidebarMode: (state) => state.sidebarMode,
  newAreaName: (state) => state.newAreaName,
}

const actions = {}

const mutations = {
  SET_NEW_POLYGON: (state, newPolygon) => {
    state.newPolygon = newPolygon
  },
  SET_IS_OVERLAPPING: (state, isOverlapping) => {
    state.isOverlapping = isOverlapping
  },
  SET_SELECTED_AREA: (state, selectedArea) => {
    state.selectedArea = selectedArea
  },

  SET_SIDEBAR_MODE: (state, mode) => {
    state.sidebarMode = mode
  },
  SET_NEW_AREA_NAME: (state, name) => {
    state.newAreaName = name
  },
  RESET_STATE: (state) => {
    state.newPolygon = null
    state.selectedArea = null
    state.isOverlapping = null
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
